import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        display: 'flex',
        flex_direction: 'row',
        align_items: 'flex-start',
        justify_content: 'flex-start',
        position: 'relative',
        border_style: 'solid',
        gap: FOUNDATIONS.spacing_250,
        padding: FOUNDATIONS.spacing_250,
        border_radius: FOUNDATIONS.radius_comp_feedback_message_borderradius,
        border_width: FOUNDATIONS.border_comp_feedback_message_bordersize,
        width: '100%',
    },
    headerContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        gap: FOUNDATIONS.spacing_150,
        // Required to avoid the auto margin right of the kubit message (that behaviour should be deleted)
        margin_right: FOUNDATIONS.spacing_00,
    },
    headerContainerLargeMessage: {
        [DeviceBreakpointsType.MOBILE]: {
            flex_direction: 'column',
        },
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
        font_weight: FONT_WEIGHT.font_bold,
        word_break: 'break-word',
    },
    contentContainer: {
        display: 'inline-flex',
        gap: FOUNDATIONS.spacing_100,
    },
    contentContainerLargeMessage: {
        [DeviceBreakpointsType.MOBILE]: {
            margin_left: FOUNDATIONS.spacing_00,
        },
    },
    description: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
        font_weight: FONT_WEIGHT.font_regular,
        word_break: 'break-word',
    },
    infoIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    closeIcon: {
        color: FOUNDATIONS.color_neutral_icon_onsurface_50,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    closeIconContainer: {
        order: '1',
    },
    buttonSectionContainer: {
        display: 'flex',
        flex_direction: 'column',
        width: '100%',
        align_items: 'flex-start',
    },
    linkContainer: {
        margin_top: FOUNDATIONS.spacing_150,
    },
    linksContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
    },
});
//# sourceMappingURL=commonStyles.js.map